import type { TemplateField } from "@/api/researchCms.service";

export function filterOrgFields(fields: TemplateField[]): TemplateField[] {
  return fields.filter(f => !f.fieldName.startsWith("individual_"));
}

export function filterIndividualFields(fields: TemplateField[]): TemplateField[] {
  return fields.filter(f => f.fieldName.startsWith("individual_"));
}

export function filterByTab(fields: TemplateField[], tab: string): TemplateField[] {
  return fields.filter(f => f.fieldTab === tab);
}
